import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"
import Loadable from "@loadable/component"

import WorkModal from "./WorkModal"
import "react-responsive-modal/styles.css"

const LoadableIframeVideo = Loadable(() => import("./IframeVideo"))

const Works = ({ isLangEn }) => {
  const data = useStaticQuery(graphql`
    query {
      imageMakingofJapanese: file(
        relativePath: { eq: "works-makingofjapanese.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageBlackboxdiaries: file(
        relativePath: { eq: "works-blackboxdiaries.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageBlackboxdiariesModal: file(
        relativePath: { eq: "works-blackboxdiaries-modal.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageOlympicEn: file(relativePath: { eq: "works-olympic-en.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageOlympicJa: file(relativePath: { eq: "works-olympic-ja.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageTempleFamily: file(relativePath: { eq: "works-templefamily.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageCloseupgendai: file(
        relativePath: { eq: "works-closeupgendai.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageCloseupgendaiModal: file(
        relativePath: { eq: "works-closeupgendai-modal.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageKoshien: file(relativePath: { eq: "works-koshien.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageMonkey: file(relativePath: { eq: "works-monkey.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 520) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageChaya: file(relativePath: { eq: "works-chaya.jpg" }) {
        childImageSharp {
          fluid(quality: 75, maxWidth: 560) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageRickshaw: file(relativePath: { eq: "works-rickshaw.jpg" }) {
        childImageSharp {
          fluid(quality: 75, maxWidth: 560) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageDearichiro: file(relativePath: { eq: "works-dearichiro.jpg" }) {
        childImageSharp {
          fluid(quality: 75, maxWidth: 560) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageIdaten: file(relativePath: { eq: "works-idaten.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 335) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageClassdivide: file(relativePath: { eq: "works-classdivide.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 335) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageChicagoland: file(relativePath: { eq: "works-chicagoland.jpg" }) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 335) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageDearichiroModal: file(
        relativePath: { eq: "works-dearichiro-modal.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageIdatenModalEn: file(
        relativePath: { eq: "works-idaten-modal-en.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
      imageIdatenModalJa: file(
        relativePath: { eq: "works-idaten-modal-ja.jpg" }
      ) {
        childImageSharp {
          fluid(quality: 65, maxWidth: 1000) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  const LinkMonkbyblood = () => {
    window.open(
      "https://www.aljazeera.com/programmes/viewfinder/asia/2013/06/2013625112631305367.html",
      "_blank",
      "noopener"
    )
  }
  const LinkDearichiro = () => {
    window.open(
      "https://creators.yahoo.co.jp/yamazakiema/",
      "_blank",
      "noopener"
    )
  }
  const LinkCineric = () => {
    window.open("https://cineric.jp/restore/", "_blank", "noopener")
  }

  const imageMakingofJapanese = data.imageMakingofJapanese.childImageSharp.fluid
  const imageBlackboxdiaries = data.imageBlackboxdiaries.childImageSharp.fluid
  const imageOlympicEn = data.imageOlympicEn.childImageSharp.fluid
  const imageOlympicJa = data.imageOlympicJa.childImageSharp.fluid
  const imageTempleFamily = data.imageTempleFamily.childImageSharp.fluid
  const imageCloseupgendai = data.imageCloseupgendai.childImageSharp.fluid
  const imageKoshien = data.imageKoshien.childImageSharp.fluid
  const imageMonkey = data.imageMonkey.childImageSharp.fluid
  const imageChaya = data.imageChaya.childImageSharp.fluid
  const imageRickshaw = data.imageRickshaw.childImageSharp.fluid
  const imageDearichiro = data.imageDearichiro.childImageSharp.fluid
  const imageClassdivide = data.imageClassdivide.childImageSharp.fluid
  const imageIdaten = data.imageIdaten.childImageSharp.fluid
  const imageChicagoland = data.imageChicagoland.childImageSharp.fluid

  const imageBlackboxdiariesModal =
    data.imageBlackboxdiariesModal.childImageSharp.fluid
  const imageCloseupgendaiModal =
    data.imageCloseupgendaiModal.childImageSharp.fluid
  const imageDearichiroModal = data.imageDearichiroModal.childImageSharp.fluid
  const imageIdatenModalEn = data.imageIdatenModalEn.childImageSharp.fluid
  const imageIdatenModalJa = data.imageIdatenModalJa.childImageSharp.fluid

  const num = []
  for (let i = 0; i < 14; ++i) {
    num.push(i * 100)
  }

  return (
    <div className="works__items">
      <div className="container">
        <div className="works-primary">
          <WorkModal
            isLangEn={isLangEn}
            workNum={num[0]}
            workTitle={
              isLangEn
                ? "THE MAKING OF A JAPANESE (2023)"
                : "小学校〜それは小さな社会〜 (2023)"
            }
            workSlug="makingofjapanese"
            workImage={imageMakingofJapanese}
            workContent={
              <>
                {isLangEn ? (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/854281218?h=dbb4cb77e0"
                        title="THE MAKING OF A JAPANESE (2023)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki (Documentary
                        Feature / 99 min)
                        <br />
                        Tokyo International Film Festival ‘23 / Thessaloniki
                        International Documentary Festival ‘24
                        <br />
                        Co-Production by Cineric Creative + NHK + Pystymestä +
                        Point Du Jour / Participation of YLE and France
                        Télévisions
                        <br />
                        World Sales Autlook Filmsales
                      </p>
                    </div>
                    <div className="modal__story modal__story--synopsis">
                      <p>
                        <i>
                          Located in one of Tokyo's sprawling suburbs, Tsukado
                        </i>{" "}
                        is one of the largest public elementary schools in Japan
                        with nearly 1,000 students. In the nation's unique
                        educational system, children are tasked to run their own
                        school in order to teach communal values and how to play
                        one's role in the group. Intimately capturing one school
                        year from the perspective of 1st and 6th graders, THE
                        MAKING OF A JAPANESE has the magic of childhood with
                        precious moments of joy, tears, and discovery — as they
                        learn the traits necessary to become part of Japanese
                        society.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Ema had the idea to film a Japanese elementary school as
                        early as 2014. While living in New York, she realized
                        that her ‘Japaneseness’ all stemmed from experiences
                        during her public elementary school years that she
                        experienced in Osaka, as she learned crucial values of
                        discipline and responsibility. Her thesis became that:
                        5-year-olds around are pretty similar, whereas a
                        12-year-old Japanese child is distinctly Japanese.
                      </p>
                      <p>
                        150 days of filming yielded over 700 hours of material.
                        Ultimately, Ema made the school itself the main
                        character while interweaving individual stories of
                        students and teachers. With no narration or interviews,
                        the viewer is invited to experience what it's like to go
                        through the Japanese school year, where the balance of
                        freedom and restraint is at question, and every life
                        lesson tows the line of growth and sacrifice.{" "}
                      </p>
                      <p>
                        Ema filmed until she was 7.5 months pregnant, giving
                        birth to her son during the editing of the film.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/865777229?h=fe6ec645f2"
                        title="小学校〜それは小さな社会〜 (2023)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        長編ドキュメンタリー映画 / 99分　監督・編集 山崎エマ
                        <br />
                        英題『THE MAKING OF A JAPANESE』
                        <br />
                        2023年 東京国際映画祭 / 2024年
                        テッサロニキ国際ドキュメンタリー映画祭 <br />
                        国際共同制作 Cineric Creative + NHK + Pystymestä + Point
                        Du Jour / 協力参加 YLE + France Télévisions
                        <br />
                        海外セールス Autlook Filmsales
                      </p>
                    </div>
                    <p>
                      東京都の郊外にある塚戸小学校は、千人近い児童数を誇るマンモス学校。日本特有の教育制度では、児童自らが学校を運営するための役割を担う。集団の大切さと、その中でどのような役割を果たすかを体感して学ぶためだ。「小学校〜それは小さな社会〜」は、小学1年生と6年生の視点から、一年間の学校生活を追い、日本社会の一員となるために必要な素養を学ぶ子どもたちの、喜び、涙、発見の貴重な瞬間を親密に描く。
                    </p>
                    <p>
                      山崎が日本の小学校を撮影しようと決意したのは2014年のこと。ニューヨークに在住していた彼女は、自分の「日本人らしさ」はすべて、大阪で過ごした公立小学校時代の、規律と責任という重要な価値観を学んだ経験に由来していることに気づいた。「5歳児は世界のどこにいても似たような存在だが、12歳の頃には、日本の子どもは『日本人』になっている。それほど小学校は鍵なのではないか」という思いから、日本社会の未来を考える上で、小学校を舞台にしたいと考えた。
                    </p>
                    <p>
                      150日間の撮影をし、700時間以上の素材が撮れた。最終的に、山崎は学校そのものを主人公にしながら、自動や教師の個々の物語を織り交ぜた。ナレーションやインタビューはなく、自由と制限のバランスが問われ、すべての人生訓が成長と犠牲の境界線をたどる日本の学校生活を体験させる作品。
                    </p>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[1]}
            workTitle="BLACK BOX DIARIES (2024)"
            workSlug="blackboxdiaries"
            workImage={imageBlackboxdiaries}
            workContent={
              <>
                <div className="modal__hero">
                  <Img fluid={imageBlackboxdiariesModal} />
                </div>
                {isLangEn ? (
                  <>
                    <div className="modal__caption">
                      <p>
                        Directed by Shiori Ito　(Documentary Feature / 103 min)
                        <br />
                        Edited + Co-Produced by Ema Ryan Yamazaki <br />
                        2024: Sundance World Cinema Documentary Competition /
                        MoMA Documentary Fortnight / SXSW / CPH DOX / Hong Kong
                        International Film Festival / Hot Docs ...and more
                        <br />
                        International Co-Production by Cineric Creative +
                        Hanashi Films + Star Sands
                      </p>
                    </div>
                    <div className="modal__story modal__story--synopsis">
                      <p>
                        BLACK BOX DIARIES follows director and journalist Shiori
                        Ito’s courageous investigation of her own sexual assault
                        in an improbable attempt to prosecute her high-profile
                        offender. Unfolding like a thriller and combining secret
                        investigative recordings, vérité shooting and emotional
                        first-person video, Shiori's quest becomes a landmark
                        case in Japan, exposing the country’s desperately
                        outdated judicial and societal systems.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Ema begin editing the film in 2020, after Shiori shared
                        with her the 400 hours of material she had gathered as
                        she went through the harrowing experience of rape,
                        investigation, and becoming a public figure. It took
                        almost 4 years of on-and-off editing periods to figure
                        out how best to put together the challenging material,
                        while maintaining a coherent perspective of the
                        Director-Subject duality.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__caption">
                      <p>
                        長編ドキュメンタリー映画/ 103分　監督 伊藤詩織
                        　編集・共同プロデューサー 山崎エマ
                        <br />
                        2024年　サンダンス映画祭ワールドシネマ・ドキュメンタリー・コンペティション部門
                        / ニューヨーク近代美術館 (MoMA) Doc Fortnight /
                        コペンハーゲン国際ドキュメンタリー映画祭 /
                        香港国際映画祭 / ホットドックス(Hot Docs)　など
                        <br />
                        国際共同制作 Cineric Creative + Hanashi Films + Star
                        Sands
                      </p>
                    </div>
                    <p>
                      『BLACK BOX
                      DIARIES』は、監督・ジャーナリストの伊藤詩織が、著名な加害者を起訴するため、自分に起きた性暴力被害事件を自ら勇気を持って調査する姿を追った作品である。まるでスリラーのような展開でくり開けられるストーリーは、極秘の調査記録、ヴェリテ撮影、感動的な一人称映像が組み合わされ、伊藤監督の探求は日本における画期的な事件となり、時代遅れの司法制度や社会制度を暴露する。
                    </p>
                    <p>
                      伊藤監督がレイプ、捜査、そして公人になるという悲惨な経験を経て集めた400時間に及ぶ映像資料を共有した後、山崎は2020年からこの映画の編集を開始。監督と被写体という二重性の一貫した視点を保ちながら、難解な素材をどのようにまとめるのがベストなのか模索しながら、4年近くの編集作業を行なった。
                    </p>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[2]}
            workTitle={
              isLangEn
                ? "Koshien: Japan’s Field of Dreams (2019)"
                : "甲子園：フィールド・オブ・ドリームス (2020)"
            }
            workSlug="Koshien"
            workImage={imageKoshien}
            workContent={
              <>
                {isLangEn ? (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/366753473?portrait=0"
                        title="Koshien: Japan’s Field of Dreams (2019)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki　（Documentary
                        Feature / 94 min）
                        <br />
                        DOC NYC ‘19 / Aired on ESPN in June 2020 / Released in
                        Japanese theaters Summer 2020
                        <br />
                        <a
                          className="link-color"
                          href="https://www.nytimes.com/2021/09/24/movies/international-streaming.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          New York Times
                        </a>{" "}
                        recommendation for international film streaming
                        <br />
                        Distributed by{" "}
                        <a
                          className="link-color"
                          href="https://firstrunfeatures.com/koshien.html"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          First Run Features
                        </a>{" "}
                        / Co-Production by Cineric Creative + NHK + NHK
                        Enterprises
                        <br />
                        Cast Tetsuya Mizutani, Hiroshi Sasaki, Shohei Ohtani,
                        Yusei Kikuchi
                      </p>
                    </div>
                    <div className="modal__story modal__story--synopsis">
                      <p>
                        Baseball is life for the die-hard competitors in{" "}
                        <i>Koshien</i>, Japan’s national high school baseball
                        championship, whose alumni include MLB baseball star
                        Shohei Ohtani and former Yankee Hideki Matsui. As
                        popular as America’s World Series, the stakes are beyond
                        high in this single-elimination tournament. However, for
                        Coach Mizutani, cleaning the grounds and greeting guests
                        are equally important as honing baseball skills,
                        demonstrating discipline, sacrifice and unwavering
                        dedication. This documentary follows Mizutani and his
                        team on their quest to win the 100th annual{" "}
                        <i>Koshien</i>, and, in the process, goes beyond
                        baseball to reveal the heart of the Japanese national
                        character.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Upon returning to Japan after living in New York for
                        nine years, Ema had a renewed outlook of the country she
                        grew up in. From the trains running on time to people
                        orderly lining up, she was drawn to how Japanese society
                        functioned efficiently and harmoniously in a way other
                        places didn’t. When watching <i>Koshien</i> for the
                        first time in a decade, she saw in high school baseball
                        — the helmets in a perfect line, the strict adherence to
                        rules, the team-first mentality — a microcosm of
                        Japanese society itself.
                      </p>
                      <p>
                        Although the final film features two teams, the filming
                        took place at four schools across Japan, with over 500
                        high school boys. Since there was no way of knowing what
                        was going to happen during the course of the season, it
                        was necessary to cover as many options as possible.
                        Collaborating with cinematographer Michael Crommett who
                        did not understand Japanese, Ema looked to accentuate
                        things that were uniquely Japanese while drawing out
                        universal emotions. With over 300 hours gathered, the
                        story came together in the edit. Ultimately, Coach
                        Mizutani’s life and the outcome of the 100th{" "}
                        <i>Koshien</i> year was used to examine a society on the
                        brink of change.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://www.youtube.com/embed/u3m_5gSmvpU"
                        title="映画『甲子園：フィールド・オブ・ドリームス』予告編"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        長編ドキュメンタリー映画 / 94分　監督・編集 山崎エマ{" "}
                        <br />
                        英題『Koshien: Japan’s Field of Dreams』
                        <br />
                        DOC NYC ‘19 / 2020年6月
                        スポーツ・チャンネルESPNにて全米放送
                        <br />
                        2020年夏より
                        <a
                          className="link-color"
                          href="https://koshien-movie.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          日本全国で公開
                        </a>
                        （配給協力 日活）
                        <br />
                        ニューヨークタイムズの「海外映画おすすめトップ５」に選出
                        <br />
                        出演　水谷哲也、佐々木洋、大谷翔平、菊池雄星　　国際共同制作
                        Cineric Creative + NHK + NHK Enterprises
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        毎年日本全国を熱狂させる高校野球。2018年、夏の甲子園は100回大会を迎えた。その歴史的な年の特別プロジェクトとしてNHK/NHKエンタープライズと取り組んだ国際共同制作。
                      </p>
                      <p>
                        主人公の横浜隼人高校の水谷哲也監督は、30年近いキャリアの中でも特別な思いでこの記念すべき年に挑んでいた。自称「昭和の頑固オヤジ」である水谷は、勝つことのみならず、挨拶や掃除などを徹底し人間形成を重要視。更には、メジャーリーガー大谷翔平や菊池雄星を輩出した花巻東高校野球部の佐々木洋監督の恩師でもある。
                      </p>
                      <p>
                        この作品ではこの2人の監督の100回大会の年を追いながら、高校野球を日本の社会の縮図と位置づけ、変わりゆく時代を考える。昭和から平成、そして未来へ。時代とともに変えるべきもの、変えてはならないもの…純粋に青春の全てをぶつける高校球児と、教育の最前線にたつ指導者の葛藤、そして喜びを見つめる。
                      </p>
                    </div>
                    <div className="modal__story">
                      <h3 className="head">オフィシャルHP</h3>{" "}
                      <p>
                        <a
                          className="link-color"
                          href="https://koshien-movie.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          甲子園：フィールド・オブ・ドリームス
                        </a>
                      </p>
                    </div>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[3]}
            workTitle={
              isLangEn
                ? "Monkey Business: The Adventures of Curious George’s Creators (2017)"
                : "モンキービジネス おさるのジョージ著者の大冒険(2018)"
            }
            workSlug="monkey"
            workImage={imageMonkey}
            workContent={
              <>
                {isLangEn ? (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://www.youtube.com/embed/Ayjx-0wZxpg"
                        title="Monkey Business: The Adventures of Curious George’s Creators (2017)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        Directed, Produced, and Edited by Ema Ryan Yamazaki
                        （Documentary Feature / 82 min）
                        <br />
                        Narrated by Sam Waterston / $186,000 raised on{" "}
                        <a
                          className="link-color"
                          href="https://www.kickstarter.com/projects/1344946756/curious-george-documentary"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Kickstarter
                        </a>
                        <br />
                        World Premiere at LA Film Festival ’17 / Audience Award
                        at Nantucket Film Festival ‘17
                        <br />
                        Distributed worldwide by The Orchard
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        Curious George is the most popular monkey in the world.
                        Since his introduction in the first publication in 1941,
                        the beloved series has sold over 75 million books in
                        more than 25 languages. MONKEY BUSINESS explores the
                        lesser-known tale of George's creators, Hans and Margret
                        Rey, who were German Jews, global refugees, immigrants,
                        artists, and Americans. On makeshift bicycles with
                        sketches of a curious little monkey aboard, they rode
                        across Nazi occupied Europe in search of a freedom that
                        would nurture one of the most treasured children’s book
                        series of all time. Using a creative mix of animation,
                        archival materials, and interviews, the film reveals the
                        authors to be just as adventurous and curious as George
                        himself.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Ema began making her first feature documentary in 2014,
                        two years after graduating from NYU. She was
                        particularly drawn to the Reys’ ability to overcome
                        being an outsider in all the places they lived in, as
                        well as their courage in choosing to call their
                        harrowing lives an “adventure.” In all the decisions
                        that were made in putting the film together, she
                        continued to ask the question: how would Hans and
                        Margret tell their own story? That led to the decision
                        to collaborate with animator Jacob Kafka, who created
                        15,000 hand-drawn drawings. In order to purposefully
                        highlight how the Reys were first and foremost
                        storytellers, the film uses animation and archival
                        materials to distinguish between the Reys’ version of
                        events and the reality of war. After two years of
                        self-funding the project through other editing jobs, Ema
                        decided to do an ambitious Kickstarter campaign. She
                        raised $186,000, and subsequently accepted a worldwide
                        distribution offer from The Orchard.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://www.youtube.com/embed/tgPlD2s5XVE"
                        title="モンキービジネス おさるのジョージ著者の大冒険 (2018)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        長編ドキュメンタリー映画 / 82 min
                        監督・プロデュース・編集 山崎エマ
                        <br />
                        英題『Monkey Business: The Adventures of Curious
                        George’s Creators』
                        <br />
                        クラウドファンディング （
                        <a
                          className="link-color"
                          href="https://www.kickstarter.com/projects/1344946756/curious-george-documentary"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          キックスターター
                        </a>
                        ）で2000万円を集める
                        <br />
                        ロサンゼルス映画祭 ‘17 / ナンタケット映画祭 ‘17
                        観客賞受賞
                        <br />
                        世界配給 米オーチャード / 日本配給
                        エスパース・サロウ　2018年
                        新宿シネマカリテ・UPLINK渋谷より全国順次公開
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        世界中で愛されている絵本「ひとまねこざる」と「おさるのジョージ」シリーズ。
                        その生みの親、ユダヤ人であるハンス・レイとマーガレット・レイ夫妻は、ナチス・ドイツの侵攻を逃れパリからアメリカに移住し、生涯ジョージのキャラクターを守り続けた。そこにはジョージに負けないほどの好奇心を持ちながら、『人生』を『冒険』と位置づけた著者の勇敢な姿があった。
                      </p>
                      <p>
                        山崎はニューヨーク大学を卒業した2年後の2014年より製作を開始。レイ夫妻の波乱万丈な人生を、世界中から集めた膨大なアーカイブ映像と、貴重な原画の数々を織り交ぜ、描いた15,000枚の手書きのアニメーションで完成させた。
                      </p>
                      <p>
                        主に大学時代の仲間と共に製作期間3年かけて取り組んだ本作。最初の2年間は、編集の仕事で稼いだ資金を制作費に回していたが、2016年夏に大規模なクラウドファンディングを実施することを決意。2000万円を集め、その後米オーチャード社の世界配給オファーを承諾した。
                      </p>
                    </div>
                    <div className="modal__story">
                      <h3 className="head">日本オフィシャルHP</h3>{" "}
                      <p>
                        <a
                          className="link-color"
                          href="http://monkeybusiness.espace-sarou.com/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          モンキービジネス おさるのジョージ著者の大冒険
                        </a>
                      </p>
                    </div>
                  </>
                )}
              </>
            }
          />
        </div>
      </div>

      <div className="container">
        <div className="works-tertiary">
          <WorkModal
            isLangEn={isLangEn}
            workNum={num[0]}
            workTitle={
              isLangEn
                ? "NHK’S CLOSE UP GENDAI (2023)"
                : "クローズアップ現代 (2023)"
            }
            workSlug="closeupgendai"
            workImage={imageCloseupgendai}
            workContent={
              <>
                <Img
                  className="modal__hero"
                  fluid={imageCloseupgendaiModal}
                  alt="CLOSE UP GENDAI Image"
                />
                {isLangEn ? (
                  <>
                    <div className="modal__caption">
                      <p>
                        Director and Studio Guest - Ema Ryan Yamazaki
                        <br />
                        (TV broadcast with documentary elements / 27 min)
                        <br />
                        Aired on prime time as NHK’s flagship current affairs
                        show, CLOSE UP GENDAI in 2023
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        Countries around the world are paying close attention to
                        “TOKKATSU,” a facet of Japanese education that includes
                        class discussions and daily classroom leaders. In Egypt,
                        where social and political turmoil has continued since
                        the “Arab Spring,” TOKKATSU was introduced by the
                        president as a nationwide policy and has been
                        revolutionary in changing the lives of students.
                        Meanwhile, in Japan, TOKKATSU is facing a turning point,
                        as activities are being cut back due to factors such as
                        issues of overworked teachers. This project considers
                        what is truly important for children’s education.{" "}
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Ema directed the documentary sections of this live
                        studio program which took place in both Egypt and Japan,
                        as well as appeared as an in-studio guest. In the 30+
                        year history of the program, it was a rare opportunity
                        for a non-NHK employee to direct this TV slot.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__caption">
                      <p>
                        ドキュメンタリー部分を含むテレビ番組 / 27分
                        <br />
                        監督 / 出演　山崎エマ
                        <br />
                        2023年12月　NHK「クローズアップ現代」にて放送
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        いま世界で、学級会や日直など日本式教育「特別活動（TOKKATSU）」に熱い視線が注がれている。「アラブの春」以降、混乱が続くエジプトでは大統領肝いりの政策として全国で導入され、子どもたちに革命的な変化が起きたと評されている。その効果とは？一方の日本ではいま特別活動が曲がり角を迎えている。働き方改革などから活動が削減されているのだ。世界を股に掛けた取材から子どもにとって大切な教育とは何か考える。
                      </p>
                      <p>
                        山崎は、本番組に含まれるドキュメンタリー部分のエジプトと日本での取材撮影を監督。スタジオゲストとしても出演した。本番組の30年以上の歴史の中で、NHKの社員以外がこの枠の監督を務めるのは稀なことである。
                      </p>
                    </div>
                  </>
                )}{" "}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[1]}
            workTitle="TOKYO 2020 OFFICIAL OLYMPIC FILM (2022)"
            workSlug="monkey"
            workImage={isLangEn ? imageOlympicEn : imageOlympicJa}
            workContent={
              <>
                <div className="modal__iframe__wrapper">
                  <LoadableIframeVideo
                    videoSrc="https://www.youtube.com/embed/Hu16KFw7gFo?si=6or7eJJ8j_VbRTUQ"
                    title="Official Film of the Olympic Games Tokyo 2020"
                  />
                </div>
                {isLangEn ? (
                  <>
                    <div className="modal__caption">
                      <p>
                        Directed by Naomi Kawase
                        <br />
                        Co-Director + Supervising Editor - Ema Ryan Yamazaki
                        <br />
                        2-part Documentary - Side A (120 minutes) and Side B
                        (123 minutes)
                        <br />
                        Cannes Film Festival ‘22
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        From a vast record of 750 days, 5,000 hours, Official
                        Film of the Olympic Games Tokyo 2020 SIDE A is an
                        official documentary by Naomi Kawase capturing not only
                        the athletes gathered from all over the world, but also
                        their families, volunteers, medical personnel, and
                        protesters shouting for the cancellation of the
                        Olympics. The film shows the passion and anguish that
                        came out of these Olympic Games.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        The production consisted of over a 100 members who
                        covered various aspects of the Tokyo Olympics, which
                        took place under difficult conditions caused by the
                        COVID pandemic. Ema mainly filmed with non-Japanese
                        athletes who had unique stories, including Kim Gaucher
                        (Basketball, Canada) and Aliphine Tuliamuk (Marathon,
                        USA) who brought their young babies to the Games.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__caption">
                      <p>
                        2部作形式長編ドキュメンタリー映画 総監督 河瀬直美 /
                        SIDE:A（120分）/ SIDE:B（123分）
                        <br />
                        英題『Official Film of the Olympic Games Tokyo 2020』
                        <br />
                        共同監督・スーパーバイジングエディター　山崎エマ
                        <br />
                        2022年　カンヌ国際映画祭　ワールドプレミア上映
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        750日間、5000時間という膨大な記録素材の中から、世界中から集まったアスリートだけでなく、その家族、ボランティア、医療関係者、そしてオリンピック中止を叫ぶデモ参加者たちの姿を捉えた河瀬直美総監督の公式ドキュメンタリー『東京2020オリンピック
                        SIDE:A』。夏期オリンピックから生まれた情熱と苦悩が伝わる作品。
                      </p>
                      <p>
                        本作品は100人以上の制作スタッフで構成され、コロナ禍で困難な状況下で開催された東京オリンピックを様々な角度から取材した。キム・ゴーシェ（女子バスケ／カナダ）、アリフィン・トゥリアムク（女子マラソン／アメリカ）など、乳児を連れて参加した外国人アスリートたちのユニークなエピソードを中心に撮影した。
                      </p>
                    </div>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[2]}
            workTitle={
              <>
                {isLangEn ? (
                  <>
                    <p>TEMPLE FAMILY (2021) / </p>
                    <p>MONK BY BLOOD (2013)</p>
                  </>
                ) : (
                  <>
                    <p>寺と家族と“私” (2021) / </p>
                    <p>お寺の子 (2013)</p>
                  </>
                )}
              </>
            }
            workSlug="templefamily"
            workImage={imageTempleFamily}
            workContent={
              <>
                {isLangEn ? (
                  <>
                    <h2 className="modal__head--additional">
                      TEMPLE FAMILY (2021)
                    </h2>

                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/916644177?h=8b0d58010e"
                        title="TEMPLE FAMILY (2021)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki
                        <br />
                        (Documentary Short / 30 min)
                        <br />
                        Aired on NHK and NHK World in 2021
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis-nonborder">
                      <p>
                        The sights and sounds at the 800-year-old Horenji Temple
                        in Kyoto Prefecture -- electro music, English, takoyaki
                        octopus balls and a kaleidoscopic elephant -- would seem
                        to belie its long history. But in order for the
                        family-run temple to thrive in the 21st century, it must
                        continue to reinvent itself. Intimately following future
                        head priest Scion (30) along with his fiancée Haruka and
                        firstborn sister Ariya, critically-acclaimed director
                        Ema Ryan Yamazaki captures one unexpected corner of
                        Japanese society's struggle to balance tradition with
                        progress.
                      </p>
                    </div>
                    <div className="modal__story modal__story--border">
                      <p>
                        TEMPLE FAMILY is a sequel to Ema’s film, MONK BY BLOOD
                        (2013). It follows the same family, 8 years later. As a
                        life-long project, Ema hopes to document this temple
                        family every decade.
                      </p>
                    </div>

                    <h2 className="modal__head--additional">
                      MONK BY BLOOD (2013)
                    </h2>

                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/79614488"
                        title="MONK BY BLOOD (2013)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki
                        <br />
                        (Documentary Short / 25 min)
                        <br />
                        Aired on Al Jazeera English in over 130 countries in
                        2013
                        <br />
                        Full Frame Documentary Film Festival '14
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis-nonborder">
                      <p>
                        Modern-day Japan is a complex nation struggling to
                        combine tradition with the demands of a globalized
                        world. With rare access to a traditional family temple
                        in Japan, Scion Sasaki’s story captures the struggle of
                        a nation as he questions his future dictated by more
                        than 20 generations past. Despite dreams of being a DJ
                        and master chef, he is destined to become the next head
                        monk and run his family temple in Kyoto, Japan. On a
                        brief trip home to Japan from university abroad, this
                        DJ-by-night and trainee-monk-by-day knows what
                        inevitably lies ahead of him, but how does he come to
                        terms with it?
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        This documentary was Ema’s first professional
                        documentary after graduation from NYU, commissioned
                        through Al Jazeera English’s Open Call process for
                        documentaries in Asia.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <h2 className="modal__head--additional">
                      寺と家族と“私” (2021)
                    </h2>

                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/916644484?h=b62381e6c8"
                        title="寺と家族と“私” (2021) "
                      />
                    </div>
                    <div className="modal__caption modal__caption--nonborder">
                      <p>
                        短編ドキュメンタリー/ 30分　監督 山崎エマ
                        <br />
                        英題『TEMPLE FAMILY』
                        <br />
                        2021年　NHK、NHKワールドにて放送
                      </p>
                    </div>
                    <div className="modal__story modal__story--border">
                      <p>
                        京都市下京区にある浄土真宗の寺、宝蓮寺。一歩足を踏み入れると、そこは多言語が飛び交い、さまざまな文化的背景を持つ人たちが集うにぎやかな空間だ。日本の多くの寺が檀家減少や後継者不足に直面する中、宝蓮寺では今後のお寺のあり方について、家族の間で活発な議論が繰り返されていた。未来を託されたのは長男で次期住職の師恩（３０歳）。婚約者の晴香と長女の阿梨耶らとともに、寺に新風を吹き込もうと模索する日々を追う。伝統と進歩とのバランスに奮闘する日本社会の意外な一面を捉える。
                      </p>
                      <p>
                        『寺と家族と“私” 〜800年を繋ぐTEMPLE
                        FAMILY〜』は山崎の短編ドキュメンタリー『MONK BY
                        BLOOD』（2013年）の続編。同じ家族の8年後を描く。山崎は生涯のプロジェクトとして、この寺の家族を定期的に記録していきたいと考えている。
                      </p>
                    </div>

                    <h2 className="modal__head--additional">お寺の子 (2013)</h2>

                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/417149603"
                        title="MONK BY BLOOD (お寺の子) - TRAILER (日本語字幕)"
                      />
                    </div>
                    <div className="modal__caption modal__caption--nonborder">
                      <p>
                        ドキュメンタリー番組/ 25分　監督・編集 山崎エマ
                        <br />
                        アルジャジーラ国際衛星テレビ局にて130ヶ国で放送・配信
                        <br />
                        フルフレームドキュメンタリー映画祭'14選出
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        佐々木師恩は長男として800年の歴史を持つ実家の寺を継ぐ事を期待されている。だが、アメリカで生まれ、カナダで大学に通う師恩の夢はシェフ。趣味でDJもやる。
                        東と西、そして生まれ持った運命と自分の夢のはざまで、21歳の若者は何を感じ、どう生きるのか？
                      </p>
                    </div>
                    <div className="modal__story">
                      <h3 className="head">このリンクから視聴可能（英語版）</h3>
                      <div
                        onClick={LinkMonkbyblood}
                        onKeyDown={LinkMonkbyblood}
                        tabIndex={-1}
                        role="button"
                        className="link-color"
                      >
                        Al Jazeera: Monk by Blood
                      </div>
                    </div>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[3]}
            workTitle={
              isLangEn
                ? "Wheels of Fate: The Story of THE RICKSHAW MAN (2020)"
                : "ウィール・オブ・フェイト～映画『無法松の一生』をめぐる数奇な運命～(2020)"
            }
            workSlug="rickshaw"
            workImage={imageRickshaw}
            workContent={
              <>
                {isLangEn ? (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/915433073?h=846d87107e"
                        title="WHEELS OF FATE (2020)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki（Short
                        Documentary / 19 minutes）
                        <br />
                        Narrated by Lily Franky / Animation by Taku Furukawa
                        <br />
                        Venice Classics ‘20 / Tokyo International Film Festival
                        ‘20
                        <br />
                        International co-production by Cineric Creative and
                        Kadokawa
                        <br />
                        Distributed around the world as a pair with the 4K
                        restoration of THE RICKSHAW MAN (1943)
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        Despite being cut down by both the wartime Japanese
                        government and the post-war US occupation forces, the
                        original 1943 version of THE RICKSHAW MAN survives as a
                        masterpiece of humanist cinema from a dark time.
                        Miyajima, longtime right hand to legendary
                        cinematographer Kazuo Miyagawa, declared that he would
                        restore THE RICKSHAW MAN even if it were his last act on
                        earth – that was before the coronavirus. WHEELS OF FATE
                        follows Miyajima’s quest to restore THE RICKSHAW MAN
                        journeying between Tokyo, New York, and Lisbon while
                        recounting its fateful history using interviews,
                        archival material, and animation.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Ema decided to make this documentary in the spring of
                        2020, when she learned that THE RICKSHAW MAN restoration
                        will go forward despite the difficulties that the
                        pandemic would bring about. 75 years after the end of
                        World War II, the project felt evermore poignant amidst
                        a dark year. The documentary was designed to be paired
                        with screenings of THE RICKSHAW MAN, in the hope to
                        provide context and showcase the strong desires of those
                        who made the film and restoration happen.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/915433113?h=d65a1af3a4"
                        title="WHEELS OF FATE (2020)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        短編ドキュメンタリー映画 / 19分 監督・編集 山崎エマ
                        <br />
                        英題『Wheels of Fate: The Story of THE RICKSHAW MAN』
                        <br />
                        ナレーション
                        リリー・フランキー　アニメーション　古川タク
                        <br />
                        ベネチア映画祭 クラシック部門 ’20 / 東京国際映画祭 '20
                        <br />
                        国際共同制作 Cineric Creative + KADOKAWA
                        <br />
                        ４K修復版の『無法松の一生』と共に世界中で配給
                      </p>
                    </div>

                    <p>
                      戦中・戦後と二度にわたる検閲を受けた『無法松の一生』(1943)。大スター阪東妻三郎が主演し、のちに『羅生門』『雨月物語』などを撮影した宮川一夫の原点と呼ばれる名画は、戦意高揚映画が飛び交う時代に輝いた、人間味溢れる作品。戦後75年経ち制作した本作では、当時の制作者たちの苦悩、ヒロイン園井恵子の被爆死など、知られざる数奇な運命を紐解くとともに、長年宮川一夫の助手を努めた宮島正弘の修復にかける想いと、コロナ禍での国境を越えた修復に密着した。
                    </p>
                    <p>
                      『無法松の一生』とは、明治末期の九州小倉を舞台に、無法松と呼ばれる人力車夫・松五郎の生き様を、哀切に満ちた心温まるエピソードとともに綴り、理想の女性に対する美しき愛情、男の真情を描く感動巨篇。2020年、
                      <span
                        onClick={LinkCineric}
                        onKeyDown={LinkCineric}
                        tabIndex={-1}
                        role="button"
                        className="link-color"
                      >
                        シネリック社が4Kデジタル修復
                      </span>
                      。
                    </p>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[4]}
            workTitle={
              isLangEn
                ? "CHAYA: Ailey’s Keeper of the Flame (2020)"
                : "CHAYA 魂の番人〜エイリー舞踊団に捧げた半生〜(2020)"
            }
            workSlug="chaya"
            workImage={imageChaya}
            workContent={
              <>
                {isLangEn ? (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/417953740?portrait=0"
                        title="CHAYA: Ailey’s Keeper of the Flame (2020)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki
                        <br />
                        （TV documentary / 49 min）
                        <br />
                        Aired on NHK and NHK World in 2020 / Co-Production by
                        Cineric Creative + NHK
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        Masazumi Chaya was part of the world-renowned Alvin
                        Ailey American Dance Theatre for 47 years, dedicating
                        his life to founder Alvin Ailey and his legacy. A dancer
                        originally from Fukuoka, Japan, he moved to New York in
                        1970 in pursuit of a career on stage. After Ailey’s
                        untimely death, Chaya dedicated his life to keeping his
                        legacy alive. The film follows the final five years of
                        Chaya’s career, as he passes on his knowledge and
                        responsibilities to the next generation, while
                        struggling to let go.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        This project began production in 2015, and took five
                        years to complete. It was Ema’s first collaboration with
                        Producer Eric Nyari, who she married in 2017. Ema also
                        created Chaya’s retirement tribute video that played at
                        New York's City Center during a special evening
                        celebrating Chaya in December 2019.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__iframe__wrapper">
                      <LoadableIframeVideo
                        videoSrc="https://player.vimeo.com/video/417950084?portrait=0"
                        title="CHAYA 魂の番人〜エイリー舞踊団に捧げた半生〜(2020)"
                      />
                    </div>
                    <div className="modal__caption">
                      <p>
                        ドキュメンタリー番組 / 49分　監督・編集 山崎エマ
                        <br />
                        英題『CHAYA: Ailey’s Keeper of the Flame』
                        <br />
                        2020年 NHK BS1スペシャル＋NHKワールドで放送
                        <br />
                        ナレーション　黒柳徹子
                        <br />
                        国際共同制作　Cineric Creative + NHK
                      </p>
                    </div>
                    <p>
                      ニューヨークを拠点とするのアルビン・エイリー・アメリカン・ダンス・シアターは、年間200公演をこなし、今まで7500万人を動員してきた。その世界的舞踊団の副芸術監督は、なんと日本人。茶谷正純さんは、1970年にニューヨークに渡り、47年間に渡りこの舞踊団と今は亡き創立者のアルビン・エイリーに人生を捧げてきた。
                    </p>
                    <p>
                      このドキュメンタリーでは、引退までの5年間を取材。残された時間で、次世代に全てを伝えたい。そんな思いと、引き際に悩む姿を追った。ナレーションは親友の黒柳徹子さん。
                    </p>
                  </>
                )}{" "}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[5]}
            workTitle={isLangEn ? "IDATEN (2019)" : "いだてん紀行 (2019)"}
            workSlug="idaten"
            workImage={imageIdaten}
            workContent={
              <>
                {isLangEn ? (
                  <>
                    <Img
                      className="modal__hero"
                      fluid={imageIdatenModalEn}
                      alt="Idaten"
                    />
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki（Short
                        Documentary Series / 47 episodes）
                        <br />
                        Aired on NHK throughout 2019, paired with the Taiga
                        Drama “IDATEN”
                        <br />
                        Produced by Documentary Japan / Yoshiko Hashimoto
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        IDATEN, NHK’s annual historical drama series tells the
                        story of Japan’s Olympic quest, from the participation
                        of the first Japanese Olympian in Stockholm 1912, to
                        hosting the Tokyo Games in 1964.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Accompanying each of the 47 drama episodes, Ema directed
                        short documentaries that featured a person, theme, or
                        event. Olympians such as Kosuke Kitajima (swimming),
                        Kosei Inoue (judo), and Homare Sawa (soccer)
                        participated in a series that thoughtfully connects
                        history to the present day.
                      </p>
                      <p>
                        In addition, Ema was responsible for the English
                        elements of the six-episode international version of the
                        drama, first aired on NHK World in May 2020.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <Img
                      className="modal__hero"
                      fluid={imageIdatenModalJa}
                      alt="Idaten"
                    />
                    <div className="modal__caption">
                      <p>
                        ドキュメンタリーシリーズ / 全47話　監督・編集 山崎エマ
                        <br />
                        NHK 総合テレビ 2019年放送
                        <br />
                        制作 ドキュメンタリージャパン / プロデューサー橋本佳子
                      </p>
                    </div>
                    <p>
                      NHKが33年ぶりに挑んだ現代大河ドラマ『いだてん』。日本が五輪に初参加した1912年のストックホルム大会から64年の東京五輪まで、日本の激動の半世紀を描いた。『いだてん紀行』は従来の「ドラマゆかりの土地紹介」とは一線を画し、毎回本編に絡む人物やテーマで構成された。北島康介や澤穂希などのオリンピアンも多数出演し、100年前のパイオニアたちが歩いた道を今に繋げる視点で90秒にまとめた。
                    </p>
                    <p>
                      さらに山崎は、2020年5月にNHKワールドにて放送された『いだてん』の国際版、『IDATEN
                      The Epic Marathon to Tokyo』の英語監修を行った。
                    </p>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[6]}
            workTitle="#dearICHIRO (2019)"
            workSlug="ichiro"
            workImage={imageDearichiro}
            workContent={
              <>
                <Img
                  className="modal__hero"
                  fluid={imageDearichiroModal}
                  alt="#Dear Ichiro (2019)"
                />
                {isLangEn ? (
                  <>
                    <div className="modal__caption">
                      <p>
                        Directed and Edited by Ema Ryan Yamazaki
                        <br />
                        (Web Documentary Series / 11 episodes)
                        <br />
                        Released on Yahoo! Japan / Co-production by Cineric
                        Creative + Yahoo! Japan!
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        In March 2019, legendary baseball player Ichiro Suzuki
                        retired. Director Ema Ryan Yamazaki, a life-long Ichiro
                        fan who calls him her life teacher, embarks on a journey
                        to capture the stories of other Ichiro fans across Japan
                        and in the US. Beyond his accomplishments in baseball,
                        the series captures the deep impact the superstar has
                        had on a generation, and the stories of people who
                        applied his influence into their own lives.
                      </p>
                    </div>
                    <div className="modal__story">
                      <h3 className="head">Available to watch here:</h3>{" "}
                      <div
                        onClick={LinkDearichiro}
                        onKeyDown={LinkDearichiro}
                        tabIndex={-1}
                        role="button"
                        className="link-color"
                      >
                        Yahoo! Japan CREATORS: Ema Ryan Yamazaki All Films
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__caption">
                      <p>
                        ドキュメンタリーシリーズ / 全11話 監督・編集 山崎エマ
                        <br />
                        Yahoo! Japanにて配信 / 共同制作 Cineric Creative +
                        Yahoo! Japan Creators Program
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        25年にわたり、日本人に感動と希望、そして目指すべき場所、志を照らしつづけてきてくれたイチロー。
                      </p>
                      <p>
                        どんな世代であっても、平成を生きた日本人であればイチローに何かしらの影響を受けてきたはずだ。平成も終わりを迎え、令和の時代に向かう社会。今こそ、日本中にある「イチロー物語」を集め、彼がくれたもの、「イチローの時代」の意味を考えるきっかけを作りたい。そして、いつか送りたいと思っていた手紙のように、敬意と感謝を込めて、イチローに届けたい。
                      </p>
                      <p>
                        そんな思いを込めて、自称「世界一のイチローファン」である映像監督
                        山崎エマが手がけるドキュメンタリーシリーズ。
                      </p>
                    </div>
                    <div className="modal__story">
                      <h3 className="head">このリンクから視聴可能</h3>
                      <div
                        onClick={LinkDearichiro}
                        onKeyDown={LinkDearichiro}
                        tabIndex={-1}
                        role="button"
                        className="link-color"
                      >
                        Yahoo! Japan CREATORS: 山崎エマ 作品一覧
                      </div>
                    </div>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[7]}
            workTitle="Class Divide (2015)"
            workSlug="classdivide"
            workImage={imageClassdivide}
            workContent={
              <>
                <div className="modal__iframe__wrapper">
                  <LoadableIframeVideo
                    videoSrc="https://www.youtube.com/embed/tyDpCz4fHE0"
                    title="Class Divide (2015)"
                  />
                </div>

                {isLangEn ? (
                  <>
                    <div className="modal__caption">
                      <p>
                        Edited and Co-Produced by Ema Ryan Yamazaki（Feature
                        Documentary / 74 minutes）
                        <br />
                        Grand Jury Prize winner at DOC NYC 2015 / Aired on HBO
                        <br />
                        Directed by Marc Levin / Produced by Blowback
                        Productions
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        At the intersection of West 26th Street and 10th Avenue
                        near the High Line in New York City, two communities are
                        separated by much more than a boulevard. With the
                        backdrop of a rapidly gentrifying neighborhood, the film
                        documents the lives and interactions of children from
                        each side of the block.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        The film was edited just a few blocks away from the
                        location where the story was taking place. As Ema
                        started editing, she also got involved in the planning
                        of on-going shooting, as she saw opportunities of how
                        the story could be captured. Together with director Marc
                        Levin, Ema tackled the challenge of creating an
                        emotional through-line while integrating the stories of
                        an ensemble cast.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__caption">
                      <p>
                        長編ドキュメンタリー映画 / 74分　編集・コープロデュース
                        山崎エマ <br />
                        DOC NYC ‘15でグランプリ受賞 / 2016年米HBO放送・配信
                        <br />
                        監督 マーク・レビン / 制作 Blowback Productions
                      </p>
                    </div>
                    <p>
                      ニューヨークの観光地ハイラインの麓にある街角。片方には学費が年間400万円かかる私立学校「アベニューズ・ザ・ワールドスクール」がそびえ立ち、裕福な家庭の子供達が通う。一方、道を渡ると貧困家庭が住む団地が並び、そこに住む子供たちは厳しい生活を余儀なくされている。
                    </p>
                    <p>
                      貧富の差が激しいニューヨークで高級化が進む中、取り合わせにいながら別世界を生きる子供達が交わっていく物語。
                    </p>
                  </>
                )}
              </>
            }
          />

          <WorkModal
            isLangEn={isLangEn}
            workNum={num[8]}
            workTitle="Chicagoland (2014)"
            workSlug="chicagoland"
            workImage={imageChicagoland}
            workContent={
              <>
                <div className="modal__iframe__wrapper">
                  <LoadableIframeVideo
                    videoSrc="https://player.vimeo.com/video/418819665?portrait=0"
                    title="Chicagoland (2014)"
                  />
                </div>

                {isLangEn ? (
                  <>
                    <div className="modal__caption">
                      <p>
                        Edited by Ema Ryan Yamazaki（Documentary Series / 8
                        episodes）
                        <br />
                        World Premiere at Sundance Film Festival ‘14 / Aired on
                        CNN
                        <br />
                        Executive Produced by Robert Redford / Created by Mark
                        Levin and Mark Benjamin
                        <br />
                        Produced by Sundance Productions + Brick City TV
                      </p>
                    </div>

                    <div className="modal__story modal__story--synopsis">
                      <p>
                        Chicagoland is a non-scripted, eight-part series
                        exploring where politics and policy meet real people's
                        lives, in a heartland American city.
                      </p>
                    </div>
                    <div className="modal__story">
                      <p>
                        Ema was one of the editors on the series, sorting
                        through thousands of hours of footage to figure out
                        story arcs and weave together the different characters’
                        lives.
                      </p>
                    </div>
                  </>
                ) : (
                  <>
                    <div className="modal__caption">
                      <p>
                        ドキュメンタリーシリーズ / 8話　編集 山崎エマ
                        <br />
                        サンダンス映画祭 ‘14でワールドプレミア / 2014年米CNN放送
                        <br />
                        制作 Sundance Productions + Brick City TV
                      </p>
                    </div>
                    <p>
                      年間の殺人事件が500を超える街シカゴで、市長のラーム・エマニュエル、シカゴ警察、そして治安の悪い高校の校長先生を1年間密着したドキュメンタリーシリーズ。政治的決断が実際に地域に与える影響と、その最前線で活躍する人々を追う。
                    </p>
                  </>
                )}
              </>
            }
          />
        </div>
      </div>
    </div>
  )
}

export default Works
